import { AxiosError } from "axios";
import { openContextModal } from "@mantine/modals";
import { objectToCamel } from "ts-case-convert";
import { somethingWentWrongModalContext } from "@/modals/SomethingWentWrong";
import { ErrorSchema } from "@/utils/isUnauthorizedError";

export const handleMutationError = (): void => {
  openContextModal(somethingWentWrongModalContext);
};

export const handleApiError = (e: Error, defaultTitle?: string, defaultCloseLabel?: string) => {
  let title: string | undefined = defaultTitle;
  let description: string | undefined = undefined;
  const closeLabel: string | undefined = defaultCloseLabel;

  if (e instanceof AxiosError) {
    const parsedError = ErrorSchema.safeParse(objectToCamel(e.response?.data));
    if (parsedError.success) {
      if ("error" in parsedError.data) {
        description = parsedError.data.error;
      } else {
        title = parsedError.data.errorMessage.title;
        description = parsedError.data.errorMessage.content;
      }
    }
  }

  openContextModal({
    modal: "somethingWentWrong",
    innerProps: {
      title,
      description,
      closeLabel,
    },
  });
};
